/** Make sure a base64 string includes the `=` padding and add them back if they are missing. */
export function ensureBase64Padding(s: string) {
  let result = s;
  const missingPadding: number = 4 - (s.length % 4);
  for (let i = 0; i < missingPadding && missingPadding !== 4; i++) {
    result += "=";
  }
  return result;
}
